import axios from 'axios';
import { Auth, Logger } from 'aws-amplify';
import { Signer, DateUtils } from '@aws-amplify/core';
import moment from 'moment';
import store from '@/store';
import * as config from '@/config';

const URL_API_HORA = config.URL_API_HORA;

// Útiles
export const executeJSONSignedRequest = function(method, url, data, thenFun, catchFun) {
	// Hace lo mismo que executeSignedRequest, pero aplica JSON.stringify a data antes
	let stringifiedData = (data !== undefined) ? JSON.stringify(data) : undefined;
	executeSignedRequest(method, url, stringifiedData, thenFun, catchFun);
};

const signerLogger = new Logger('SignedRequest', 'DEBUG');

export const executeSignedRequest = function(method, url, data, thenFun, catchFun, retryWithClockOffset) {
	// De ser necesario, data puede ser undefined (por ejemplo, en un GET)
	// Por defecto, si petición falla, reintentar con hora corregida.
	retryWithClockOffset = (retryWithClockOffset === undefined) ? true : retryWithClockOffset;
	
	let exitoAuth = function(sessionObject) {
		let sessionToken = sessionObject.sessionToken;
		let accessKeyId = sessionObject.accessKeyId;
		let secretAccessKey = sessionObject.secretAccessKey;

		// Usar Signer para firmar petición. Para el proceso se usa la hora LOCAL.
		// Véase https://aws-amplify.github.io/amplify-js/api/classes/signer.html
		let request = {
			method,
			url,
			data
		};
		
		let accessInfo = {
			access_key: accessKeyId, 
			secret_key: secretAccessKey,
			session_token: sessionToken,
		};
		
		let serviceInfo = null;
		
		// https://stackoverflow.com/questions/60554364/authenticate-to-aws-with-axios-and-aws4
		let signedRequest = Signer.sign(request, accessInfo, serviceInfo);
		delete signedRequest.headers['host'];
		let axiosInstance = axios.create();
		
		axiosInstance(signedRequest).then(function(response) {
			// Petición tuvo éxito, ejecutar callback then
			thenFun(response);
		})
		.catch(function(err) {
			// Petición falló.
			// Ver si posiblemente falló con 403. Si es así y si se pidió reintentar con
			// hora corregida, reintentar.
			let isNetworkError = (err.toString() === 'Error: Request failed with status code 403');
			if(isNetworkError && retryWithClockOffset) {
				// Reintentar corrigiendo hora
				let exitoTime = function(millisEpoch) {
					// Obtener hora local y remota. Calcular diferencia para que al momento de la firma
					// se compense la diferencia.
					let remoteTimeMillisEpoch = Number(moment(millisEpoch).format('x'));
					let localTimeMillisEpoch = Number(moment().format('x'));
					let clockOffset = remoteTimeMillisEpoch - localTimeMillisEpoch;
					// Establecer offset. Es un valor global: Signer.sign usa DateUtils.getClockOffset().
					DateUtils.setClockOffset(clockOffset);
					// Reintentar. CUIDADO, en esta llamada a executeSignedRequest se DEBE establecer 
					// retryWithClockOffset=false para evitar recursión sin fin.
					executeSignedRequest(method, url, data, thenFun, catchFun, false);
				};
				
				// Obtener tiempo remoto.
				axios.get(URL_API_HORA).
				then(function(res) {
					let millisEpoch = res.data.requestTimeEpoch;
					exitoTime(millisEpoch);
				}).
				catch(function(err) {
					catchFun('Error al hacer petición, posiblemente hora local sea incorrecta. Pruebe corregirla e intente nuevamente.');
				});
			}
			else {
				// NO reintentar, fallar de una vez!
				catchFun(err);
			}
		});
	};
	
	let errorAuth = function(err) {
		catchFun(`Error al obtener credenciales para firmar petición`);
	};

	Auth.currentCredentials().then(resp=>{

		// se centraliza la llamada a las credenciales por medio de una funcion
		// que retorna una promesa con las credenciales del usuario para
		// AWS -- 21-08-20
		// Auth.currentCredentials().then(exitoAuth).catch(errorAuth);
		store.dispatch('usuario/getAWSCredentials').then(exitoAuth).catch(errorAuth);
	}).catch(err=>{
		store.dispatch('usuario/onSessionExpired', err);
	});
	
};
